import React, { useState } from 'react';
import { Loader2, ImageIcon } from 'lucide-react';

interface ImageWithLoaderProps {
  src: string;
  alt: string;
  className?: string;
  fallbackClassName?: string;
  onError?: () => void;
}

const ImageWithLoader: React.FC<ImageWithLoaderProps> = ({
  src,
  alt,
  className = '',
  fallbackClassName = '',
  onError
}) => {
  const [isLoading, setIsLoading] = useState(true);
  const [hasError, setHasError] = useState(false);

  const handleLoad = () => {
    setIsLoading(false);
  };

  const handleError = () => {
    setIsLoading(false);
    setHasError(true);
    onError?.();
  };

  return (
    <div className="relative">
      {/* Loading Spinner */}
      {isLoading && !hasError && (
        <div className={`absolute inset-0 flex items-center justify-center bg-brinsa-celeste/10 rounded-xl ${className}`}>
          <div className="text-center">
            <Loader2 className="w-8 h-8 text-brinsa-azul animate-spin mx-auto mb-2" />
            <p className="text-xs text-brinsa-azulOscuro/70">Cargando imagen...</p>
          </div>
        </div>
      )}

      {/* Imagen real */}
      {!hasError && (
        <img
          src={src}
          alt={alt}
          className={`${className} ${isLoading ? 'opacity-0' : 'opacity-100'} transition-opacity duration-300`}
          onLoad={handleLoad}
          onError={handleError}
        />
      )}

      {/* Fallback si falla la carga */}
      {hasError && (
        <div className={`flex items-center justify-center bg-brinsa-celeste/10 rounded-xl border border-brinsa-celeste/30 ${fallbackClassName || className}`}>
          <div className="text-center">
            <ImageIcon className="w-12 h-12 text-brinsa-azul/40 mx-auto mb-2" />
            <p className="text-xs text-brinsa-azulOscuro/60">Imagen no disponible</p>
          </div>
        </div>
      )}
    </div>
  );
};

export default ImageWithLoader;